import * as React from 'react';

function SvgHelpCenterCommission(props) {
  return (
    <svg height={64} width={63} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M56.223 8.93a6 6 0 015.997 6.175l-.878 30.257-21.268 18.639H15.6a6 6 0 01-6-6V14.93a6 6 0 016-6z"
          fill="#e2f4f2"
        />
        <path
          d="M40.764.033c5.343 0 8.64 2.643 8.76 7.529l.003.279v5.042c0 1.184-.786 2.145-2.06 2.145-1.217 0-1.99-.879-2.054-1.992l-.005-.153V7.84c0-2.619-1.643-3.9-4.391-3.973l-.253-.004H8.774c-2.815 0-4.54 1.205-4.64 3.742l-.004.235v38.204c0 2.618 1.643 3.9 4.391 3.973l.253.003H19.73c1.273 0 2.306.732 2.306 1.916 0 1.133-.945 1.852-2.141 1.912l-.165.004H8.774c-5.343 0-8.64-2.644-8.76-7.53l-.003-.278V7.84C.011 2.87 3.209.135 8.474.036l.3-.003zm9.402 19.877a1.31 1.31 0 011.615.112l5.047 4.695 1.946 1.775.12.13c.36.45.32 1.092-.12 1.501l-1.946 1.81L35.17 49.968l-3.875.437-.302.027c-3.19.213-5.374-1.89-4.99-4.895l.469-3.603 23.554-21.911zm.8 4.097L29.995 43.4l-.104.198-.327 2.547c-.072.752.27 1.07 1.087 1.001l2.73-.303.21-.095 20.972-19.394zm-33.49 13.096c1.273 0 2.305.73 2.305 1.915 0 1.133-.944 1.852-2.141 1.912l-.165.004h-4.784c-1.273 0-2.306-.731-2.306-1.916 0-1.133.945-1.85 2.141-1.911l.165-.004zM27.11 25.45c1.274 0 2.306.73 2.306 1.915 0 1.133-.944 1.852-2.141 1.912l-.165.004h-14.51c-1.274 0-2.307-.731-2.307-1.916 0-1.133.945-1.851 2.141-1.911l.165-.004zm9.7-12.504c1.274 0 2.307.732 2.307 1.916 0 1.133-.945 1.851-2.142 1.912l-.164.004H12.6c-1.273 0-2.306-.731-2.306-1.916 0-1.133.945-1.851 2.141-1.912l.165-.004z"
          fill="#38b2a6"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default SvgHelpCenterCommission;
